
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ReviewBadges from './components/ReviewBadges';
import ReviewCTA from './components/ReviewCTA';
import BusinessHours from './components/BusinessHours';
import ContactForm from './components/ContactForm';
import ServiceAreas from './components/ServiceAreas';
import { useSEO, generateServiceSchema, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function ServicesPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painting & Decorating Services Watford | Brushour Hertfordshire',
    description: 'Professional painting and decorating services in Watford, Hertfordshire – interior painting, exterior painting, wallpaper installation, commercial painting, and decorative finishes. Free quotes available across Hertfordshire.',
    keywords: 'painting services Watford, interior painting Hertfordshire, exterior painting Watford, wallpaper installation Hertfordshire, commercial painting Watford, decorating services Hertfordshire',
    canonical: `${SITE_URL}/services`,
    schema: [
      generateServiceSchema(),
      generateWebPageSchema('Painting & Decorating Services – Brushour Watford', 'Full range of professional painting and decorating services across Watford and Hertfordshire', `${SITE_URL}/services`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Services', url: `${SITE_URL}/services` },
      ]),
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ServicesHero />
      <ReviewBadges />
      <ServicesList />
      <ServiceAreas />
      <BusinessHours />
      <ReviewCTA />
      <ContactForm />
      <Footer />
    </div>
  );
}
